// source: pbtypes/gen/skills/keyframe_trans.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_body_trans_pb = require('../../../pbtypes/gen/body/trans_pb.js');
goog.object.extend(proto, pbtypes_gen_body_trans_pb);
var pbtypes_gen_eigen_lcm_Vector2d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2d_pb);
var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
goog.exportSymbol('proto.skills.KeyframeTrans', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.KeyframeTrans = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.KeyframeTrans, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.KeyframeTrans.displayName = 'proto.skills.KeyframeTrans';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.KeyframeTrans.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.KeyframeTrans.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.KeyframeTrans} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.KeyframeTrans.toObject = function(includeInstance, msg) {
  var f, obj = {
unitSpeedTimeAlongTraj: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
position: (f = msg.getPosition()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
orientationPy: (f = msg.getOrientationPy()) && pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject(includeInstance, f),
vehiclePose: (f = msg.getVehiclePose()) && pbtypes_gen_body_trans_pb.TransPb.toObject(includeInstance, f),
flightId: jspb.Message.getFieldWithDefault(msg, 5, ""),
utimeAdded: jspb.Message.getFieldWithDefault(msg, 6, 0),
poseGraphVertexUtime: jspb.Message.getFieldWithDefault(msg, 7, 0),
gimbalRoll: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.KeyframeTrans}
 */
proto.skills.KeyframeTrans.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.KeyframeTrans;
  return proto.skills.KeyframeTrans.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.KeyframeTrans} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.KeyframeTrans}
 */
proto.skills.KeyframeTrans.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUnitSpeedTimeAlongTraj(value);
      break;
    case 2:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 3:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.setOrientationPy(value);
      break;
    case 4:
      var value = new pbtypes_gen_body_trans_pb.TransPb;
      reader.readMessage(value,pbtypes_gen_body_trans_pb.TransPb.deserializeBinaryFromReader);
      msg.setVehiclePose(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFlightId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtimeAdded(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setPoseGraphVertexUtime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGimbalRoll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.KeyframeTrans.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.KeyframeTrans.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.KeyframeTrans} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.KeyframeTrans.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnitSpeedTimeAlongTraj();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getOrientationPy();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
  f = message.getVehiclePose();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_body_trans_pb.TransPb.serializeBinaryToWriter
    );
  }
  f = message.getFlightId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUtimeAdded();
  if (f !== 0) {
    writer.writeSint64(
      6,
      f
    );
  }
  f = message.getPoseGraphVertexUtime();
  if (f !== 0) {
    writer.writeSint64(
      7,
      f
    );
  }
  f = message.getGimbalRoll();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
};


/**
 * optional double unit_speed_time_along_traj = 1;
 * @return {number}
 */
proto.skills.KeyframeTrans.prototype.getUnitSpeedTimeAlongTraj = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.KeyframeTrans} returns this
 */
proto.skills.KeyframeTrans.prototype.setUnitSpeedTimeAlongTraj = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional eigen_lcm.Vector3dPb position = 2;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.skills.KeyframeTrans.prototype.getPosition = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 2));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.skills.KeyframeTrans} returns this
*/
proto.skills.KeyframeTrans.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.KeyframeTrans} returns this
 */
proto.skills.KeyframeTrans.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.KeyframeTrans.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional eigen_lcm.Vector2dPb orientation_py = 3;
 * @return {?proto.eigen_lcm.Vector2dPb}
 */
proto.skills.KeyframeTrans.prototype.getOrientationPy = function() {
  return /** @type{?proto.eigen_lcm.Vector2dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 3));
};


/**
 * @param {?proto.eigen_lcm.Vector2dPb|undefined} value
 * @return {!proto.skills.KeyframeTrans} returns this
*/
proto.skills.KeyframeTrans.prototype.setOrientationPy = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.KeyframeTrans} returns this
 */
proto.skills.KeyframeTrans.prototype.clearOrientationPy = function() {
  return this.setOrientationPy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.KeyframeTrans.prototype.hasOrientationPy = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional body.TransPb vehicle_pose = 4;
 * @return {?proto.body.TransPb}
 */
proto.skills.KeyframeTrans.prototype.getVehiclePose = function() {
  return /** @type{?proto.body.TransPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_body_trans_pb.TransPb, 4));
};


/**
 * @param {?proto.body.TransPb|undefined} value
 * @return {!proto.skills.KeyframeTrans} returns this
*/
proto.skills.KeyframeTrans.prototype.setVehiclePose = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.KeyframeTrans} returns this
 */
proto.skills.KeyframeTrans.prototype.clearVehiclePose = function() {
  return this.setVehiclePose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.KeyframeTrans.prototype.hasVehiclePose = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string flight_id = 5;
 * @return {string}
 */
proto.skills.KeyframeTrans.prototype.getFlightId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.KeyframeTrans} returns this
 */
proto.skills.KeyframeTrans.prototype.setFlightId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional sint64 utime_added = 6;
 * @return {number}
 */
proto.skills.KeyframeTrans.prototype.getUtimeAdded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.KeyframeTrans} returns this
 */
proto.skills.KeyframeTrans.prototype.setUtimeAdded = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional sint64 pose_graph_vertex_utime = 7;
 * @return {number}
 */
proto.skills.KeyframeTrans.prototype.getPoseGraphVertexUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.KeyframeTrans} returns this
 */
proto.skills.KeyframeTrans.prototype.setPoseGraphVertexUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional double gimbal_roll = 8;
 * @return {number}
 */
proto.skills.KeyframeTrans.prototype.getGimbalRoll = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.KeyframeTrans} returns this
 */
proto.skills.KeyframeTrans.prototype.setGimbalRoll = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


goog.object.extend(exports, proto.skills);
